export class GenericType {
  Type:number;
  Name:string;

  public constructor(public readonly _type: number, public readonly _name: string) {
    this.Type = _type;
    this.Name = _name;
  }

}
